



















































































































import BaseComponent from '@/components/BaseComponent';
import { Component, Prop } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import { userMdl } from '@/models/userMdl';

@Component
export default class GroupUser extends BaseComponent {
    // @Prop({ default: false }) private is_display!: boolean;
    @Prop({ default: '' }) private group_name!: string;
    @Prop({ default: -1 }) private group_id!: number;
    private is_display: boolean = true;

    // ヘッダー情報
    private userDataHeader: any = [{ text: 'ユーザ名', align: 'center', value: 'user_name' }];
    private userDataList: any = [];
    private groupUserDataList: userMdl[] = []; // グループに登録済みユーザ一覧
    private nongroupUserDataList: userMdl[] = []; // グループに登録してないユーザ一覧
    private itemsPerPage: number = 30; // 1ページに表示するアイテム数
    private selectUser: userMdl[] = []; // 選択ユーザデータ
    private selectNonUser: userMdl[] = []; // 選択グループなしユーザデータ

    private searchUser: string = ''; // ユーザデータ検索用
    private searchNonUser: string = ''; // 未登録ユーザデータ検索用

    created() {
        this.getGroupData();
    }
    private closeDialog(v: boolean) {
        this.$emit('closeDialog', v);
    }

    private onClickRowGroup(data: any) {
        let idx: number = this.selectUser.indexOf(data);
        if (idx >= 0) {
            this.selectUser.splice(idx, 1);
        } else {
            this.selectUser.push(data);
        }
    }
    private onClickRowNonGroup(data: any) {
        let idx: number = this.selectNonUser.indexOf(data);
        if (idx >= 0) {
            this.selectNonUser.splice(idx, 1);
        } else {
            this.selectNonUser.push(data);
        }
    }
    private onClickLeft() {
        let idx: number = 0;
        for (let i = 0; i < this.selectNonUser.length; i++) {
            this.groupUserDataList.push(this.selectNonUser[i]);
            idx = this.nongroupUserDataList.indexOf(this.selectNonUser[i]);
            if (idx >= 0) {
                this.nongroupUserDataList.splice(idx, 1);
            }
        }
        this.selectNonUser = [];
    }
    private onClickRight() {
        let idx: number = 0;
        for (let i = 0; i < this.selectUser.length; i++) {
            this.nongroupUserDataList.push(this.selectUser[i]);
            idx = this.groupUserDataList.indexOf(this.selectUser[i]);
            if (idx >= 0) {
                this.groupUserDataList.splice(idx, 1);
            }
        }
        this.selectUser = [];
    }
    private async onClickConfirm() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);
            let idx: number = this.userDataList.findIndex(
                ({ group_id }: { group_id: number }) => group_id === this.group_id
            );
            let params = { group_id: this.group_id, user: this.groupUserDataList };
            const resp: AxiosResponse<any> = await this.$http.post('user_group_edit.php', params, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'success',
                        timeout: 5000,
                        message: 'データ登録完了',
                        return_flg: false,
                    });
                    this.$emit('closeDialog', true);
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    this.validationErrors = resp.data.errors;
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'ユーザ登録失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'ユーザ登録失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
    // グループデータ取得
    private async getGroupData() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = { group_id: this.group_id };
            const resp: AxiosResponse<any> = await this.$http.post('user_group_data.php', params, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                    if (resp.data.groupitems != false) {
                        this.groupUserDataList = resp.data.groupitems.map(function(v: any) {
                            return new userMdl(userMdl.toJsonDataOnModel(v));
                        });
                    }

                    if (resp.data.nonegroupitems != false) {
                        this.nongroupUserDataList = resp.data.nonegroupitems.map(function(v: any) {
                            return new userMdl(userMdl.toJsonDataOnModel(v));
                        });
                    }
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'PARAM_ERROR':
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                case 'DATA_NOTFOUND_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
}
